import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import firebase from 'firebase';

@Injectable()
export class DataProvider {

  constructor(public http: HttpClient) { }

  getLanguages(): Promise<Array<string>> {

    return new Promise((resolve, reject) => {
      firebase.database().ref('/languages').once('value')
        .then(snapshot => {

          resolve(Object.keys(snapshot.val()));
        })
        .catch(error => {
          this.handleError(error);
        });
    });
  }

  getDefaultUserTypes(): Promise<Array<string>> {

    return new Promise<Array<string>>((resolve, reject) => {
      firebase.database().ref('/userClassifications/default').once('value')
        .then(snapshot => {
          if (snapshot)
            if (snapshot.val())
              resolve(Object.values(snapshot.val()));

          reject();
        })
        .catch(error => {
          this.handleError(error);
        });
    });
  }

  getPrimaryUserTypes(): Promise<Array<string>> {

    return new Promise<Array<string>>((resolve, reject) => {
      firebase.database().ref('/userClassifications/primary').once('value')
        .then(snapshot => {
          if (snapshot)
            if (snapshot.val())
              resolve(Object.values(snapshot.val()));

          reject();
        })
        .catch(error => {
          this.handleError(error);
        });
    });
  }

  getSecondaryUserTypes(primary: string): Promise<Array<string>> {

    return new Promise<Array<string>>((resolve, reject) => {
      firebase.database().ref('/userClassifications/secondary')
        .child(primary)
        .once('value')
        .then(snapshot => {
          if (snapshot)
            if (snapshot.val())
              resolve(Object.values(snapshot.val()));

          reject();
        })
        .catch(error => {
          this.handleError(error);
        });
    });
  }

  getCountriesListInvestor(credUnCred: string): Promise<Array<string>> {
    var countries = [];

    return new Promise((resolve, reject) => {
      firebase.database().ref('/countryCityData/investorCountries').child(credUnCred).once('value')
        .then(snapshot => {
          for (var key in snapshot.val()) {
            countries.push(snapshot.val()[key]);
          }

          resolve(countries);
        })
        .catch(error => {
          this.handleError(error);
        });
    });
  }

  getCountriesList(): Promise<Array<string>> {
    var countries = [];

    return new Promise((resolve, reject) => {
      firebase.database().ref('/countryCityData/countryList').once('value')
        .then(snapshot => {
          for (var key in snapshot.val()) {
            countries.push(snapshot.val()[key]);
          }

          resolve(countries);
        })
        .catch(error => {
          this.handleError(error);
        });
    });
  }

  getCities(country): Promise<any> {
    var cities = [];

    return new Promise((resolve, reject) => {
      firebase.database().ref('/countryCityData/countryCityList')
        .orderByChild("Country").equalTo(country)
        .once('value')
        .then(snapshot => {

          for (var key in snapshot.val()) {
            cities.push(snapshot.val()[key].City);
          }

          resolve(cities);
        })
        .catch(error => {
          this.handleError(error);
        });
    });
  }

  getInvestorCountriesList(): Promise<Array<string>> {
    var countries = [];

    return new Promise((resolve, reject) => {
      firebase.database().ref('/countryCityData/investorData/countries').once('value')
        .then(snapshot => {
          for (var key in snapshot.val()) {
            countries.push(snapshot.val()[key]);
          }

          resolve(countries);
        })
        .catch(error => {
          this.handleError(error);
        });
    });
  }

  getInvestorStatesList(country): Promise<any> {

    return new Promise((resolve, reject) => {
      firebase.database().ref('/countryCityData/investorData/states')
        .child(country)
        .once('value')
        .then(snapshot => {
          resolve(snapshot.val());
        })
        .catch(error => {
          this.handleError(error);
        });
    });
  }

  getOrderTrackingDataItem() {

    return new Promise((resolve, reject) => {

      firebase.database().ref('/orderData/trackingItem').once('value', snapshot => {
        if (snapshot) {
          resolve(snapshot.val());
        } else {
          reject();
        }
      }).catch(error => {
        this.handleError(error);
      });
    });
  }

  getOrderTrackingDataFood() {

    return new Promise((resolve, reject) => {

      firebase.database().ref('/orderData/trackingFood').once('value', snapshot => {
        if (snapshot) {
          resolve(snapshot.val());
        } else {
          reject();
        }
      }).catch(error => {
        this.handleError(error);
      });
    });
  }

  handleError(error) {
    console.error('An error occurred', error);
    return Promise.reject(error.message || error);
  }
}



// WEBPACK FOOTER //
// ./src/services/data.service.ts